import { createQueryKeys } from '../../factories/queryKeyFactory';

export const SECODA_ENTITIES_NAMESPACE = ['resource', 'all'];

export const secodaEntitiesQueryKeyFactory = createQueryKeys<
	string | 'bulkUpdate'
>(SECODA_ENTITIES_NAMESPACE);
